module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic-ext57.857026d.woff2";